import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import isEmpty from 'lodash/fp/isEmpty';

import { Loading } from '@autopass-web/mochi-component';

import { PATH } from '../../config';
import storage from '../../service/storage';
import { useBootStraps } from '../../services/use-bootstraps';

interface ToyotaLexusWrapperProps {
  children: React.ReactNode;
}

const ALLOWED_PATHS = [
  PATH.MAIN,
  PATH.EXPIRED,
  PATH.MAPS,
  PATH.ORDERS,
  PATH.CONTACT,
  PATH.AUTH,
  PATH.STREET_PARKING_AUTOPAY,
  PATH.POINTS,
].filter((p) => p !== null);
const AUTH_REQUIRED_PATHS = [
  PATH.MAIN,
  PATH.EXPIRED,
  PATH.ORDERS,
  PATH.CONTACT,
  PATH.STREET_PARKING_AUTOPAY,
  PATH.POINTS,
  PATH.POINTS,
].filter((p) => p !== null);

const checkIsAllowedPath = (path: string) =>
  ALLOWED_PATHS.some((p) => path.includes(p));

export const checkIsAuthRequiredPath = (path: string) =>
  AUTH_REQUIRED_PATHS.some((p) => path.includes(p));

export const ToyotaLexusWrapper = ({ children }: ToyotaLexusWrapperProps) => {
  useBootStraps();
  const [hasCheckRouting, setHasCheckRouting] = useState<boolean>(false);
  const { asPath, replace, push, query } = useRouter();

  useEffect(() => {
    const navigateToAuth = async () => {
      await push({
        pathname: PATH.AUTH,
        query: {
          ...query,
          prevPath: asPath,
        },
      });
      setHasCheckRouting(true);
    };

    async function checkPath() {
      if (hasCheckRouting) return;

      if (!checkIsAllowedPath(asPath)) {
        await replace(PATH.EXPIRED);
        setHasCheckRouting(true);
        return;
      }

      const oneTimeToken = query.OneTimeToken as string | undefined;

      // If oneTimeToken exists, redirect to auth page
      if (oneTimeToken) {
        await navigateToAuth();
        return;
      }

      const auth = storage.getAuth();
      const hasAuth = !isEmpty(auth);

      if (hasAuth) {
        // FIXME: This is a weird workaround to fix the problem that the page gets 404 while first accessing the page
        await replace(asPath);
        setHasCheckRouting(true);
        return;
      }

      // If the path is auth required, redirect to auth page
      if (checkIsAuthRequiredPath(asPath)) {
        await navigateToAuth();
        return;
      }

      // FIXME: This is a weird workaround to fix the problem that the page gets 404 while first accessing the page
      await replace(asPath);
      setHasCheckRouting(true);
    }

    checkPath();
  }, [asPath, push, replace, hasCheckRouting, query]);

  if (!hasCheckRouting) return <Loading />;

  return children;
};
